export default "__VITE_ASSET__DMcA_7ih__"